import { parseLocalizedDocsPath } from "./docs-routes";
import en from "../framework-messages/en.json";
import esEs from "../framework-messages/es-ES.json";
import es419 from "../framework-messages/es-419.json";
import ko from "../framework-messages/ko.json";
import ru from "../framework-messages/ru.json";
import ptBr from "../framework-messages/pt-BR.json";
import frFr from "../framework-messages/fr-FR.json";
import frCa from "../framework-messages/fr-CA.json";
import zhHans from "../framework-messages/zh-Hans.json";
import zhHant from "../framework-messages/zh-Hant.json";
import de from "../framework-messages/de.json";
import nl from "../framework-messages/nl.json";
import sv from "../framework-messages/sv.json";
import cs from "../framework-messages/cs.json";
import no from "../framework-messages/no.json";
import vi from "../framework-messages/vi.json";

const catalogs: Record<string, Record<string, string>> = {
  en: en,
  "es-ES": esEs,
  "es-419": es419,
  ko: ko,
  ru: ru,
  "pt-BR": ptBr,
  "fr-FR": frFr,
  "fr-CA": frCa,
  "zh-Hans": zhHans,
  "zh-Hant": zhHant,
  de: de,
  nl: nl,
  sv: sv,
  cs: cs,
  no: no,
  vi: vi,
};

export function getFrameworkTranslator(pathname: string) {
  const { locale } = parseLocalizedDocsPath(pathname);
  const messages = catalogs[locale];
  return (
    english: string,
    values: Readonly<Record<string, string>> = {},
  ): string => {
    // Keep JSX spacing even when a translation provider trims a catalog value.
    const translated = (messages[english] ?? english).replace(
      /\{([A-Za-z][A-Za-z0-9]*)\}/g,
      (placeholder, name: string) => values[name] ?? placeholder,
    );
    return `${english.match(/^\s*/)?.[0] ?? ""}${translated.trim()}${english.match(/\s*$/)?.[0] ?? ""}`;
  };
}
